document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.collection-products').forEach((collection) => {
    const track = collection.querySelector('.product-track');
    const prevBtn = collection.querySelector('.leftArrow');
    const nextBtn = collection.querySelector('.rightArrow');
    if (!track || !prevBtn || !nextBtn) return;

    const items = Array.from(track.children).filter((n) => n.nodeType === 1);
    if (!items.length) return;

    const getPaddingLeft = () =>
      parseFloat(getComputedStyle(track).paddingLeft) || 0;
    const getMaxScrollLeft = () =>
      Math.max(0, Math.round(track.scrollWidth - track.clientWidth));

    function getFirstVisibleIndex() {
      const scrollLeft = Math.round(track.scrollLeft);
      for (let i = 0; i < items.length; i++) {
        const itemStart = Math.round(items[i].offsetLeft);
        const itemEnd = itemStart + Math.round(items[i].offsetWidth);
        if (itemEnd > scrollLeft) return i;
      }
      return items.length - 1;
    }

    function getLastVisibleIndex() {
      const rightEdge = track.scrollLeft + track.clientWidth - 1;
      for (let i = items.length - 1; i >= 0; i--) {
        if (items[i].offsetLeft < rightEdge) return i;
      }
      return 0;
    }

    function scrollToIndex(index) {
      index = Math.max(0, Math.min(items.length - 1, index));
      const maxScrollLeft = getMaxScrollLeft();

      let left;
      // If it's the final item, go to the very end
      if (index === items.length - 1) {
        left = maxScrollLeft;
      } else {
        // Normal behaviour: align item to left edge (account for track padding)
        left = Math.max(
          0,
          Math.round(items[index].offsetLeft - getPaddingLeft()),
        );
        // But never exceed the true max scroll
        left = Math.min(left, maxScrollLeft);
      }

      // Smooth scroll with fallback
      if ('scrollBehavior' in document.documentElement.style) {
        track.scrollTo({ left, behavior: 'smooth' });
      } else {
        track.scrollLeft = left;
      }
    }

    prevBtn.addEventListener('click', () => {
      const first = getFirstVisibleIndex();
      scrollToIndex(first > 0 ? first - 1 : 0);
    });

    nextBtn.addEventListener('click', () => {
      const first = getFirstVisibleIndex();
      scrollToIndex(Math.min(items.length - 1, first + 1));
    });

    function updateButtons() {
      const first = getFirstVisibleIndex();
      const last = getLastVisibleIndex();
      prevBtn.disabled = first <= 0;
      nextBtn.disabled = last >= items.length - 1;
    }

    track.addEventListener('scroll', () =>
      requestAnimationFrame(updateButtons),
    );
    window.addEventListener('resize', () =>
      requestAnimationFrame(updateButtons),
    );

    updateButtons();
  });
});

// Dynamic announcement bar: height observer + seamless scrolling marquee
document.addEventListener('DOMContentLoaded', () => {
  const stickyHeaderEl = document.querySelector('sticky-header');
  if (stickyHeaderEl) {
    const setHeaderHeight = () => {
      document.documentElement.style.setProperty(
        '--header-height',
        stickyHeaderEl.offsetHeight + 'px',
      );
    };
    if (window.ResizeObserver) {
      new ResizeObserver(setHeaderHeight).observe(stickyHeaderEl);
    }
    setHeaderHeight();
  }

  // Announcement marquee: hold a constant glide speed regardless of message
  // count or viewport width, by deriving the animation duration from the
  // measured track width. The Liquid renders .brimm-marquee__track (animated in
  // custom.css via --marquee-duration); this only tunes that duration.
  //
  // NB: the previous setupBrimmMarquee() that built its own .brimm-marquee-outer
  // DOM was removed here — it was superseded by the Liquid .brimm-marquee__track
  // and conflicted with it (that's the same reason it was already disabled). Its
  // one useful idea, duration = distance / speed, is reused below on the real track.
  //
  // Speed: the demo runs ~28px/s (1246px / 45s). (The earlier mobile
  // "sluggishness" was the flex-shrink track-collapse bug, not this value —
  // fixed in custom.css.) 40 reads a touch livelier than the demo; drop to 28
  // to match the demo exactly. Adjust this one number to taste.
  const BRIMM_MARQUEE_SPEED = 40; // px/s

  function setBrimmMarqueeDurations() {
    const reduce =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('.brimm-marquee__track').forEach((track) => {
      if (reduce) {
        track.style.animationPlayState = 'paused';
        return;
      }
      const travel = track.scrollWidth * 0.5; // half the content = one loop's worth
      if (!travel) return;
      // Drive BOTH the shift (px) and the duration from the same measured width, so
      // the keyframe's travel distance and its duration can never disagree (which is
      // what made a constrained track crawl before the flex-shrink:0 fix).
      track.style.setProperty('--marquee-shift', travel + 'px');
      track.style.setProperty(
        '--marquee-duration',
        travel / BRIMM_MARQUEE_SPEED + 's',
      );
      track.style.animationPlayState = '';
    });
  }

  // Fonts change text width, so wait for them before the first measure.
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready
      .then(setBrimmMarqueeDurations)
      .catch(setBrimmMarqueeDurations);
  } else {
    setBrimmMarqueeDurations();
  }
  window.addEventListener('load', setBrimmMarqueeDurations);

  let brimmMarqueeResizeTimer = null;
  window.addEventListener('resize', () => {
    clearTimeout(brimmMarqueeResizeTimer);
    brimmMarqueeResizeTimer = setTimeout(setBrimmMarqueeDurations, 150);
  });

  // PDP media gallery — main-image prev/next arrows (custom.css re-shows
  // Dawn's .slider-buttons at all widths, overlaid on the image like
  // brimm-demo/product-page.html's .carousel-btn). Dawn's own
  // <slider-component> click handler only scrolls the underlying <ul> by
  // measuring slide widths, but the "thumbnail_slider"/"thumbnail" gallery
  // layouts set every non-active slide to display:none — so every slide but
  // the active one measures 0 width and SliderComponent.initPages() bails
  // out (sliderItemsToShow.length < 2), making the native click handler a
  // silent no-op. The real "which image is active" state lives in
  // <media-gallery>'s setActiveMedia(), which is what a thumbnail click
  // calls — so wire these buttons into that instead, looping at the ends
  // like the demo's carousel does.
  document.querySelectorAll('media-gallery').forEach((gallery) => {
    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    const sliderButtons =
      viewer && viewer.querySelector(':scope > .slider-buttons');
    const prevBtn =
      sliderButtons && sliderButtons.querySelector('.slider-button--prev');
    const nextBtn =
      sliderButtons && sliderButtons.querySelector('.slider-button--next');
    if (!viewer || !prevBtn || !nextBtn) return;

    function goToStep(step) {
      // Scope to .product__media-item — the modal-opener <button> inside each
      // slide also carries its own (differently-valued) data-media-id.
      const ids = Array.from(
        viewer.querySelectorAll('.product__media-item[data-media-id]'),
      ).map((el) => el.dataset.mediaId);
      if (ids.length < 2) return;
      const activeEl =
        viewer.querySelector('.product__media-item.is-active[data-media-id]') ||
        viewer.querySelector('.product__media-item[data-media-id]');
      const currentIndex = ids.indexOf(activeEl.dataset.mediaId);
      const nextIndex = (currentIndex + step + ids.length) % ids.length;
      gallery.setActiveMedia(ids[nextIndex], false);
    }

    prevBtn.addEventListener('click', (event) => {
      event.preventDefault();
      goToStep(-1);
    });
    nextBtn.addEventListener('click', (event) => {
      event.preventDefault();
      goToStep(1);
    });
  });

  // PDP media gallery — main image height. Dawn's "constrain to viewport"
  // (constrain_to_viewport: true) sizes the image with a flat
  // `100vh - 170px` offset (see --viewport-offset in section-main-product.css)
  // that has no idea the thumbnail row sits below it, so on this gallery's
  // "thumbnail_slider" layout the thumbnails spill below the fold.
  // brimm-demo's .hero-gallery__main instead sizes to
  // `100vh - header - thumbRowHeight`, so the whole gallery (image +
  // thumbnails) fits without scrolling. The demo expresses that in vw units
  // because its gallery is a plain full-width 50/50 grid; ours sits in a
  // page-width-constrained 55/45 grid, so there's no fixed vw fraction to
  // hardcode — measure the real rendered header/thumbnail heights instead.
  //
  // Setting --constrained-height alone isn't enough: Dawn's own rule is
  // `.media { padding-top: min(var(--constrained-height), var(--ratio-percent)) }`
  // — that min() only ever SHRINKS the box toward the image's natural aspect
  // ratio, it never grows it taller. Most of our product photos are square
  // (--ratio-percent: 100%, ~the container's width), which is always smaller
  // than our target height, so min() silently picks the natural ratio every
  // time and the container renders square regardless of what we set. Setting
  // padding-top directly (inline, so it wins outright over that min()) is
  // what actually forces the taller box — object-fit: cover then crops the
  // (mostly square, whitespace-padded) source photos to fill it, matching
  // the demo's edge-to-edge crop instead of a shrunk photo on a white field.
  // Desktop only (750px+), matching the demo's own breakpoint; mobile keeps
  // Dawn's default (the demo's mobile main image is a fixed, unrelated 480px).
  function setPdpGalleryMainHeight() {
    const isDesktop = window.matchMedia('(min-width: 750px)').matches;
    document.querySelectorAll('.product__media-wrapper').forEach((wrapper) => {
      const containers = wrapper.querySelectorAll(
        '.product-media-container.constrain-height',
      );
      if (!containers.length) return;

      if (!isDesktop) {
        containers.forEach((c) => {
          c.style.removeProperty('--constrained-height');
          const media = c.querySelector('.media');
          if (media) media.style.removeProperty('padding-top');
        });
        return;
      }

      const thumbSlider = wrapper.querySelector('.thumbnail-slider');
      const mediaList = wrapper.querySelector('.product__media-list');
      if (!thumbSlider || !mediaList) return;
      // Use the wrapper's own rendered top rather than the header's bottom —
      // there's section/grid padding between the two, and measuring from the
      // wrapper itself accounts for it (and anything else) automatically.
      const wrapperTop = wrapper.getBoundingClientRect().top;
      const thumbHeight = thumbSlider.getBoundingClientRect().height;
      // Fixed gap between the main image and the thumbnail row below it
      // (component-slider/section-main-product's media-list margin-bottom) —
      // constant regardless of image height, so measure it once per pass.
      const mediaListGap =
        parseFloat(getComputedStyle(mediaList).marginBottom) || 0;
      const minHeight = 400;
      let height = Math.max(
        minHeight,
        window.innerHeight - wrapperTop - thumbHeight - mediaListGap,
      );
      // This formula is driven by viewport HEIGHT only — at narrower browser
      // widths (roughly 750-950px, where the column itself is narrow but the
      // viewport is still tall) it keeps requesting a box far taller than
      // it is wide. object-fit: cover still crops correctly and never
      // truncates the product, but a very tall/narrow box shows the FULL
      // height of a mostly-square, whitespace-padded source photo, which
      // reads as a big band of plain backdrop above/below the product,
      // right before the thumbnails — easy to mistake for a layout gap.
      // Cap how far past the column's own width the height can stretch.
      const maxHeight = wrapper.getBoundingClientRect().width * 1.15;
      height = Math.min(height, maxHeight);
      containers.forEach((c) => {
        c.style.setProperty('--constrained-height', height + 'px');
        const media = c.querySelector('.media');
        if (media) media.style.paddingTop = height + 'px';
      });
    });
  }

  // PDP media gallery — flush the gallery column against the edge(s) of the
  // browser window, matching brimm-demo's .hero-gallery (a plain full-bleed
  // grid with no page-width wrapper: 50/50 columns at desktop, full width
  // on mobile — confirmed by measuring the demo's own mobile rendering,
  // .hero-gallery__main is genuinely x:0 to the viewport's full width
  // there too, not just inset like Dawn's default page-width layout). Our
  // product section sits inside the theme's page-width container, so the
  // media column is inset from the viewport edge same as everything else.
  //
  // Desktop: widen the column by its own currently-measured left offset
  // and cancel that offset with a matching negative margin — the right
  // edge (and the info column beside it, whose own text stays inset from
  // ITS edge same as before) stays exactly where it already is; only the
  // left edge moves to 0.
  //
  // Mobile: the info column stacks BELOW the gallery instead of beside it,
  // so there's no sibling position to preserve — bleed both edges to the
  // full viewport width.
  //
  // ".product.grid" (base.css) is display:flex, not CSS grid, so simply
  // setting a bigger width isn't enough on desktop — flex-shrink (default 1
  // on both columns) immediately shrinks the widened column straight back
  // down to fit the row, undoing it. flex-shrink: 0 on both columns stops
  // that; the info column then keeps its current width/position untouched,
  // and the row's content total is allowed to exceed the page-width
  // container (nothing here clips overflow, so it bleeds instead of
  // wrapping). Runs before setPdpGalleryMainHeight, below: widening the
  // column also widens the (square) thumbnails, which that function
  // measures to size the main image.
  function setPdpGalleryFlushLeft() {
    const isDesktop = window.matchMedia('(min-width: 750px)').matches;
    document.querySelectorAll('.product__media-wrapper').forEach((wrapper) => {
      const infoWrapper = wrapper.parentElement.querySelector(
        '.product__info-wrapper',
      );
      // Reset first so the measurement below reflects the un-adjusted
      // layout, not a stale offset left over from a previous pass.
      wrapper.style.removeProperty('margin-left');
      wrapper.style.removeProperty('margin-right');
      wrapper.style.removeProperty('width');
      wrapper.style.removeProperty('max-width');
      wrapper.style.removeProperty('flex-shrink');
      if (infoWrapper) {
        infoWrapper.style.removeProperty('width');
        infoWrapper.style.removeProperty('flex-shrink');
      }
      const rect = wrapper.getBoundingClientRect();
      if (rect.left <= 0) return;

      if (!isDesktop) {
        wrapper.style.marginLeft = -rect.left + 'px';
        wrapper.style.width = '100vw';
        wrapper.style.maxWidth = 'none';
        return;
      }

      if (infoWrapper) {
        infoWrapper.style.width =
          infoWrapper.getBoundingClientRect().width + 'px';
        infoWrapper.style.flexShrink = '0';
      }
      wrapper.style.marginLeft = -rect.left + 'px';
      wrapper.style.width = rect.width + rect.left + 'px';
      // .product--medium's own rule also sets max-width: 55%, which caps
      // the box back down regardless of the width above — clear it too.
      wrapper.style.maxWidth = 'none';
      wrapper.style.flexShrink = '0';
    });
  }

  // PDP media gallery — hide the thumbnail row's own prev/next scroll
  // arrows when every thumbnail already fits in view. Dawn decides whether
  // to render them from a hardcoded media_count threshold in the Liquid
  // (<=3/<=4 images), which assumed its own narrower default column width —
  // now that the column is flush-left and wider, more thumbnails fit
  // without scrolling than that threshold accounts for, so the arrows can
  // show even with nothing left to scroll to. Checked at runtime instead
  // (scrollWidth > clientWidth = genuine overflow) since "how many fit" is
  // viewport-width-dependent. Only ever hides them beyond what Dawn's own
  // classes already do — never force-shows an arrow Dawn decided to hide.
  function setPdpThumbnailArrowVisibility() {
    document
      .querySelectorAll('.product__media-wrapper .thumbnail-slider')
      .forEach((slider) => {
        const list = slider.querySelector('.thumbnail-list');
        const prevBtn = slider.querySelector('.slider-button--prev');
        const nextBtn = slider.querySelector('.slider-button--next');
        if (!list || !prevBtn || !nextBtn) return;
        const hasOverflow = list.scrollWidth > list.clientWidth + 1;
        [prevBtn, nextBtn].forEach((btn) => {
          if (hasOverflow) {
            btn.style.removeProperty('display');
          } else {
            btn.style.display = 'none';
          }
        });
      });
  }

  function refreshPdpGalleryLayout() {
    setPdpGalleryFlushLeft();
    setPdpGalleryMainHeight();
    setPdpThumbnailArrowVisibility();
  }

  refreshPdpGalleryLayout();
  window.addEventListener('load', refreshPdpGalleryLayout);
  let pdpGalleryResizeTimer = null;
  window.addEventListener('resize', () => {
    clearTimeout(pdpGalleryResizeTimer);
    pdpGalleryResizeTimer = setTimeout(refreshPdpGalleryLayout, 150);
  });
});
